export default "__VITE_ASSET__DnoC9FTJ__"